import { render, staticRenderFns } from "./NewsletterMultiplePickerInput.vue?vue&type=template&id=6fa00070&scoped=true&"
import script from "./NewsletterMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./NewsletterMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa00070",
  null
  
)

export default component.exports